var _script, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStxTokenLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _script || (_script = /*#__PURE__*/React.createElement("script", {
    id: "stx-token-logo_svg__argent-x-extension",
    "data-extension-id": "dlcobpjiigpikoobohmabehhmhfoodbb"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#EF6438"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 25l-3.686-5.786h5.293V17.03H7v2.185h5.293L8.607 25h2.743l4.329-6.793L20.007 25h2.743zm1.607-10.093v-2.186h-5.186L22.814 7H20.05l-4.371 6.9L11.307 7H8.543l3.643 5.721H7v2.208l17.357-.022z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStxTokenLogo);
export default __webpack_public_path__ + "static/media/stx-token-logo.c49c8d7465c5cf9776f512e153dca93d.svg";
export { ForwardRef as ReactComponent };